
import loginMixin from "@/mixins/login"

export default loginMixin.extend({
  layoutProps: {
    titleToken: "login.title.registrationEmail",
  },

  data: () => ({
    email: "",
    apiErr: {} as Record<string, any>,
    isLoading: false,
    isDone: false,
    isClosed: false,
  }),

  computed: {
    status (): string {
      const status = this.$route.query.status as string
      return status in
        (this.$t("common.specialStatus") as unknown as Record<string, string>)
        ? status
        : ""
    },

    statusLabel (): string {
      // @ts-ignore
      return this.$t("common.specialStatus")[this.status] || ""
    },
  },

  methods: {
    async onSubmit (): Promise<void> {
      this.isLoading = true
      const [, err] = await this.$api.user.sendToken({
        email: this.email,
        status: this.status || undefined,
      })
      if (!err) this.isDone = true
      else this.apiErr = err
      this.isLoading = false
    },
  },
})
